import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import ContainerService from '../../../../services/ContainerService';
import { groupByNew } from '../../../../utils/util';
import Breadcrumbs from '../../../../components/UI/Breadcrumbs';

const MapYard = (props) => {
    const [stacks, setStacks] = useState([]);

    useEffect(() => {
        onSearch()
        // eslint-disable-next-line
    }, []);

    const onSearch = () => {
        props.getMap((response) => {
            const arrayMap = [];
            const isMap = groupByNew(response, 'position');

            isMap.forEach(element => {
                if (element.value.length === 1) {
                    const array1 = [];
                    for (let index = 1; index < element.value[0].heightMax + 1; index = index + 1) {
                        const positonValue = `${element.value[0].position}.${index} (VAZIA)`;
                        array1.push({
                            key: positonValue,
                            position: index
                        });
                    }
                    arrayMap.push(array1.sort(
                        (a, b) => (a.position < b.position) ? 1 : ((b.position < a.position) ? -1 : 0)));
                } else {
                    const array1 = [];
                    for (let index = 1; index < element.value[0].heightMax + 1; index = index + 1) {
                        let key = `${element.value[0].position}.${index} (VAZIA)`

                        if (element.value[index]) {
                            key = `${element.value[index].containerNumber}`;
                        }
                        array1.push({
                            key: key,
                            position: index
                        });
                    }
                    arrayMap.push(array1.sort(
                        (a, b) => (a.position < b.position) ? 1 : ((b.position < a.position) ? -1 : 0)));
                }
            });

            setStacks(arrayMap);
        });
    }

    return (
        <div>
            <Breadcrumbs
            />

            <div className="container-fluid" style={{ marginTop: '30px' }}>
                <div className="container">
                    <div className="col s12 center">
                        <button type="button" className="btn blue" onClick={onSearch}>
                            Atualizar
                        </button>
                    </div>
                    <div className='row'>
                        {stacks.length > 0 && stacks.map((items, stackIndex) => (
                            <div key={stackIndex} className={`col s6 m4`} >
                                <h6 className="center">{`Posições ${items[0].key.split(".")[0]}.${items[0].key.split(".")[1]}`}</h6>
                                <div
                                    id={`stack-${stackIndex + 1}`}
                                    className="card-panel grey lighten-4"
                                    style={{ minHeight: "300px" }}
                                >
                                    {items.map(item => (
                                        <div
                                            key={item.key}
                                            id={`stack-${stackIndex}-${item.key}`}
                                            className="card-panel white-text center teal lighten-2"
                                            style={{
                                                cursor: "grab",
                                                margin: "5px 0",
                                            }}
                                        >
                                            {item.key}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}</div>

                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    user: state.userReducer.user
});

const mapDispatchToProps = (dispatch) => ({
    getMap: (callback) => dispatch(ContainerService.getPositionsMap(callback))
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MapYard));
